export default "__VITE_ASSET__bf5e07e0__"